import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from '@mui/material';
import { Groups, ArrowForward } from '@mui/icons-material';

interface SessionCompletionModalProps {
  isOpen: boolean;
  sessionId: string;
  playerInitiated?: boolean;
}

const SessionCompletionModal: React.FC<SessionCompletionModalProps> = ({ isOpen, sessionId, playerInitiated }) => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        sx: {
          bgcolor: '#1e293b',
          border: '1px solid #334155',
          borderRadius: '16px',
          maxWidth: '480px',
          width: '100%',
        }
      }}
    >
      <div className="p-8 text-center">
        <div className="mx-auto mb-6 size-16 rounded-full bg-blue-500/20 flex items-center justify-center">
          <Groups className="text-blue-400" style={{ fontSize: '2rem' }} />
        </div>

        <h2 className="text-2xl font-bold text-white mb-2">
          All-hands meeting starting now
        </h2>

        <p className="text-slate-400 mb-8">
          {playerInitiated
            ? "You're heading to the conference room. Let's see how you did."
            : "Time's up! The team is gathering in the conference room. Let's see how you did."
          }
        </p>

        <button
          onClick={() => navigate(`/results/${sessionId}`)}
          className="inline-flex items-center gap-2 bg-blue-500 text-white font-bold px-8 py-3 rounded-lg hover:bg-blue-400 transition-colors"
        >
          See Results
          <ArrowForward fontSize="small" />
        </button>
      </div>
    </Dialog>
  );
};

export default SessionCompletionModal;
